import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';

import * as _ from 'lodash';
import { Subscription } from 'rxjs';
import { MatSnackBar } from '@angular/material/snack-bar';
import { UserSchema, UserService, XeroxMessages, AuthService } from 'src/app/core';
import { checkPasswords, iranPhoneValidator } from 'src/app/shared';

@Component({
  selector: 'app-setting',
  templateUrl: './setting.component.html',
  styleUrls: ['./setting.component.scss'],
})
export class SettingComponent implements OnInit {
  private _subscriptions: Subscription[] = [];
  private set subscriptions(subscription: Subscription) {
    this._subscriptions.push(subscription);
  }

  personalUserForm!: FormGroup;
  phoneChangeActivationFormGroup!: FormGroup;
  changePasswordFormGroup!: FormGroup;

  userObject: UserSchema = {} as UserSchema;
  isUserActivated!: boolean;

  constructor(private userService: UserService, private snakebar: MatSnackBar, private authService: AuthService, private formBuilder: FormBuilder) {
    this.personalUserForm = new FormGroup({
      fullName: new FormControl('', [
        Validators.minLength(3),
        Validators.maxLength(50),
      ]),

      nationalCode: new FormControl('', [
        Validators.minLength(10),
        Validators.maxLength(10),
      ]),

      birthDate: new FormControl('', []),
      email: new FormControl(''),
    });

    this.phoneChangeActivationFormGroup = this.formBuilder.group({
      phone: [this.userObject.phone, [
        Validators.required,
        iranPhoneValidator,
        Validators.minLength(10),
        Validators.maxLength(10),
      ]],
    });

    this.changePasswordFormGroup = new FormGroup(
      {
        currentPassword: new FormControl('', [Validators.minLength(10)]),
        confirmPass: new FormControl('', [Validators.minLength(10)]),
        pass: new FormControl('', [Validators.minLength(10)]),
      },
      { validators: checkPasswords }
    );
  }

  ngOnInit() {
    // Update data on user configuration.
    this.subscriptions = this.userService.status$.subscribe((statusObj) => {
      if (statusObj.payload && statusObj.status === 'update') {
        this.userObject = statusObj.payload;
      }
    });

    // this.userService.getUser().then((user) => {
    //   this.userObject = user;
    // });

    this.authService.userProfile?.subscribe((userProfile) => {
      this.userObject = userProfile;
    });
  }

  /**
   * The form field that we use to update user phone number.
   */
  get newPhoneNumber() {
    return this.phoneChangeActivationFormGroup.get('phone') as FormControl;
  }

  /**
   * First removes empty objects then transmits the process flow to
   * user service.
   */
  async updateUserPersonalDataRequest() {
    let personalUserForm = { ...this.personalUserForm.value };

    for (let key in personalUserForm) {
      if (!!!personalUserForm[key] || personalUserForm[key] === '')
        delete personalUserForm[key];
    }

    this.personalUserForm.reset();

    // Update the user
    this.subscriptions = this.userService
      .updateUser(personalUserForm)
      .subscribe((user) => {
        this.userObject = user;
      });
  }

  /**
   * Update user data by getting user data from server.
   */
  updateUserData() {
    // this.userService.getUser().then((user) => {
    //   this.userObject = user;
    // });
    this.authService.userProfile?.subscribe((userProfile) => {
      this.userObject = userProfile;
    });
  }

  /**
   * Change and update User password.
   */
  changeUserPassword() {
    const changePasswordData = this.changePasswordFormGroup.value;

    if (changePasswordData.pass !== changePasswordData.confirmPass) {
      this.openDefaultSnakebar(
        'رمز عبور جدید و تکرار رمز عبور باهم برابر نیستند'
      );
    }

    this.subscriptions = this.userService
      .changeUserPassword({
        currentPassword: changePasswordData.currentPassword,
        newPassword: changePasswordData.pass,
      })
      .subscribe(
        (updateResult) => {
          this.openDefaultSnakebar(
            XeroxMessages.USER_UPDATE.success.SUCCESS_USER_PASSWORD_CHANGE
          );
          this.changePasswordFormGroup.reset();
        },

        (changingPasswordError: unknown) => {
          this.openDefaultSnakebar('مشکل در تغییر رمز عبور کاربر');
        }
      );
  }

  public openDefaultSnakebar(message: string): void {
    this.snakebar.open(message, 'برنامه !', { duration: 1000 });
  }

  ngOnDestroy() {
    this._subscriptions.forEach((subscription) => {
      subscription.unsubscribe();
    });
  }
}
